import { render, staticRenderFns } from "./visited.vue?vue&type=template&id=0b3d144b"
import script from "./visited.vue?vue&type=script&lang=js"
export * from "./visited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports